import { AppContext } from 'contexts/AppProvider'
import { useContext } from 'react'
import useModal from 'hooks/useModal'
import { MAXIMUM_SHARE_COUPONS } from 'variables/dineIn'

enum InvalidReasons {
  None = 'None',
  NoneMembership = 'NoneMembership',
  LimitSharingCoupons = 'LimitSharingCoupons',
  AlreadySharedCoupon = 'AlreadySharedCoupon',
}

export interface ValidateResult {
  pass: boolean
  invalid: InvalidReasons
}

interface UseShareCouponProps {
  totalUserSharedCoupons: number
}

const useShareCoupon = ({ totalUserSharedCoupons }: UseShareCouponProps) => {
  const { currentMembership } = useContext(AppContext)
  const modalNoneMembership = useModal()
  const modalLimitSharingCoupons = useModal()
  const modalEmptyCoupons = useModal()

  const validateShareCoupon = (_allowedSharingCoupon: boolean): ValidateResult => {
    if (!currentMembership) {
      return { pass: false, invalid: InvalidReasons.NoneMembership }
    }

    if (totalUserSharedCoupons >= MAXIMUM_SHARE_COUPONS) {
      return { pass: false, invalid: InvalidReasons.LimitSharingCoupons }
    }

    if (_allowedSharingCoupon) {
      return { pass: false, invalid: InvalidReasons.AlreadySharedCoupon }
    }

    return { pass: true, invalid: InvalidReasons.None }
  }

  const handleInvalidShareCoupon = ({
    validationResult,
    goToShareCouponPage,
  }: {
    validationResult: ValidateResult
    goToShareCouponPage: VoidFunction
  }) => {
    const actions = {
      [InvalidReasons.NoneMembership]: () => modalNoneMembership.setOpen(true),
      [InvalidReasons.LimitSharingCoupons]: () => modalLimitSharingCoupons.setOpen(true),
      [InvalidReasons.AlreadySharedCoupon]: goToShareCouponPage,
    }
    actions[validationResult.invalid]?.()
  }

  return {
    validateShareCoupon,
    handleInvalidShareCoupon,
    modalNoneMembership,
    modalLimitSharingCoupons,
    modalEmptyCoupons,
  }
}

export default useShareCoupon
